import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { IFormKey } from 'src/app/modules/shared/models/forms';

export const prev_search_employer_form_template = {
  socialReason: null,
  pIVA: null,
  employerCode: null,
  filterByProduct: false
};

export const prev_search_employer_form_validators = {
  socialReason: [],
  pIVA: [],
  employerCode: [],
  filterByProduct: []
};

export const prev_search_employer_form_keys: IFormKey[] = [
  {
    id: 'socialReason',
    label: 'Ragione Sociale',
    controlName: 'socialReason',
    type: 'INPUT',
    css: 'col-4',
  },
  {
    id: 'pIVA',
    label: 'P.IVA',
    controlName: 'pIVA',
    type: 'INPUT',
    css: 'col-4',
  },
  {
    id: 'employerCode',
    label: 'Codice Datore',
    controlName: 'employerCode',
    type: 'INPUT',
    css: 'col-4',
  },
  {
    id: 'filterByProduct',
    label: 'Filtra per Prodotto',
    controlName: 'filterByProduct',
    type: 'CHECKBOX',
    css: 'col-4',
  },
];

export const prev_search_employer_table_modal_keys: ITableKey[] = [
  {
    key: 'id',
    label: '',
    type: 'RADIO',
  },
  {
    key: 'socialReason',
    label: 'Ragione Sociale',
  },
  {
    key: 'pIVA',
    label: 'P.IVA',
  },
  {
    key: 'conventioned',
    label: 'Convenzionato',
  },
  {
    key: 'employerCode',
    label: 'Codice Datore',
  },
  {
    key: 'productDescription',
    label: 'Prodotto Polizza',
  },
  {
    key: 'productConvention',
    label: 'Prodotto Convenzione',
  },
];

export const MISSING_EMPLOYER_CODE_MESSAGE: string =
  "L'azienda selezionata non ha un codice datore associato al prodotto dell'iscritto.\n È necessario procedere alla creazione di un nuovo codice datore.";
